export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "Back to homepage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ホームに戻る"])}
    }
  })
}
